export default __webpack_public_path__ + "static/media/hmd_s1.df0c9d36.png";